import React, { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import { Button, Typography } from "@mui/material";

const MainColorButton = ({
  href,
  label,
  size,
  withIcon,
  style,
  disabled = false,
  onClick,
}) => {
  const [endY, setEndY] = useState(0);
  return (
    <div
      onTouchStartCapture={(e) => {
        setEndY(0);
      }}
      onTouchMoveCapture={(e) => {
        setEndY(e.touches[0].clientY);
      }}
      onTouchEndCapture={(e) => {
        if (endY !== 0) {
          e.stopPropagation();
        }
      }}
    >
      <Button
        variant="contained"
        endIcon={withIcon && <SendIcon />}
        size={size}
        href={href}
        onTouchEndCapture={(e) => {
          e.preventDefault();
          onClick();
        }}
        disabled={disabled}
        sx={{
          ...style,
          boxShadow: 5,
          color: "black",
          backgroundColor: "#c5e1a5",
          "&:disabled": {
            backgroundColor: "grey",
          },
          "&:hover": {
            backgroundColor: "#c5e1a5",
          },
        }}
      >
        {!!style?.variant ? (
          <Typography variant={style.variant}>{label}</Typography>
        ) : (
          <p>{label}</p>
        )}
      </Button>
    </div>
  );
};

export default MainColorButton;
